import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../data.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-usuarios-edit',
  templateUrl: './usuarios-edit.component.html',
  styleUrls: ['./usuarios-edit.component.css']
})
export class UsuariosEditComponent implements OnInit {
  errMsg:any;
  okMsg:any;
  loading:boolean=false;
  resultado:any=[];
  rol:any=[];
  idRol:number=-1;
  idRolActual:number = -1;
  jefe:any=[];
  tiempoMsg:number=3200;
  activo:boolean = true;
  esNuevo:boolean;
  esDuplicado:boolean = false;
 
  enviandoCorreo:number=-1;
  admonCorreo:any=[];
  envioMail:any;
   
  thisForm = new FormGroup({
    usuario: new FormControl(this.data.item.idUsuario, [Validators.required, Validators.minLength(3)]),
    nombre: new FormControl(this.data.item.nombre, [Validators.required, Validators.minLength(5)]),
    email: new FormControl(this.data.item.mail, [Validators.required, Validators.minLength(7)]),
    rol: new FormControl(this.data.item.idRol, [Validators.required])
  });

  constructor(private dataService: DataService, public dialogRef: MatDialogRef<UsuariosEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    //console.log(this.data);
    if(this.data){
      if(this.data.id > 0){
        this.esNuevo=false;
        this.activo = this.data.item.activo;
        this.idRolActual = this.data.item.idRol;
      }
      else
        this.esNuevo=true;
    }
    this.dataService.getRoles2().subscribe(
                      rows => {   
                              this.rol = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnRolesCargados());
    this.dataService.existeUsrJefe().subscribe(
                        rows => {   
                                this.jefe = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnExisteJefeCargado());         
    this.dataService.getVars("ENV_LOG").subscribe(
                          rows => {   
                                  this.enviandoCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnEnvio_Correo_Log_Obtenido());                                   
  }

  fnRolesCargados(){
    //console.log(this.rol);
  }

  fnExisteJefeCargado(){
    //console.log(this.jefe)
  }
  
  fnEnvio_Correo_Log_Obtenido(){
    //console.log(this.enviandoCorreo);
    if(this.enviandoCorreo == 1){
      //this.correoLog = this.enviandoCorreo[0].;
      this.dataService.getEnvioLog().subscribe(
                          rows => {   
                                  this.admonCorreo = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnAdmonLogObtenido());
    }
  }

  fnAdmonLogObtenido(){
    //console.log(this.admonCorreo);
  }

  fnKeyPress(t, e){
    this.errMsg="";
    if (!this.dataService.validKey(t,e)){
        this.errMsg="Caracter inválido!";
        setTimeout(() => {
            this.errMsg="";
        }, this.tiempoMsg);
        return false;
    }
    else
      return true;
  }

  fnKeyUp(t, e){
    //console.log(e);
  }

  onBlur(event){
    this.dataService.isUsuarioDup(this.thisForm.controls["usuario"].value).subscribe(
                          rows => {   
                                  this.resultado = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnUsuarioDuplicado());
  }

  fnUsuarioDuplicado(){
    this.esDuplicado = false;
    if(this.resultado > 0){
      this.fnMuestraMensaje("ERR", "El usuario ya ha sido dado de alta; elija otro o edite el existente.", false, false);
      this.thisForm.controls["usuario"].markAsDirty();
      var aux = <HTMLInputElement>document.getElementById("txtUsuario");
      this.esDuplicado=true;
      aux.focus();
    }
  }

  fnMuestraMensaje(tipo:string, msg:string, changeLoading:boolean, closeDialog:boolean){
    this.okMsg = "";
    this.errMsg = "";
    if(tipo=="OK")
      this.okMsg = msg;
    if(tipo=="ERR")
      this.errMsg = msg;
    setTimeout(() => {
      this.okMsg = "";
      this.errMsg = "";
      if(changeLoading)
        this.loading = !this.loading;
      if(closeDialog)
        this.dialogRef.close();
    }, this.tiempoMsg);
  }

  fnDesactivar(){
    this.activo = false;
  }

  fnActivar(){
    this.activo = true;
  }

  
  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="ROL"){
      this.idRol = idEl;
      this.thisForm.controls["rol"].setValue(this.idRol);
    }
  }

  fnGuardar(){
    this.loading = true;
    if(this.esNuevo){
      //console.log("GUARDAR");
      //console.log(this.thisForm.controls["usuario"].value)
      //--> Descuento con nombre, mínimo 3 caracteres, asignación de valor (porcentaje):
      if(this.thisForm.valid){
        var alertaJefe = false;
        if(this.thisForm.controls["rol"].value == 10){
          alertaJefe = true;
          //console.log("Ya existe un Jefe de Taquilla dado de alta!");
          this.fnMuestraMensaje("ERR", "Solo puede haber un 'Jefe de Taquilla' activo.", true, false);
          return;
        }

        this.dataService.insUsuario(this.activo, this.thisForm.controls["usuario"].value, this.thisForm.controls["nombre"].value, this.thisForm.controls["email"].value, this.thisForm.controls["rol"].value).subscribe(
                        rows => {   
                                this.resultado = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnUsuarioGuardado());           
      }
      else{
        //console.log(this.thisForm.controls["forma"].errors);
        if(this.thisForm.controls["usuario"].errors){
          if(this.thisForm.controls["usuario"].errors.required){
            this.fnMuestraMensaje("ERR", "Capture el 'usuario' con el que se identificará en el sistema.", true, false);
            return;
          }
          if(this.thisForm.controls["usuario"].errors.minlength){
            //console.log(this.thisForm.controls["usuario"].errors.minlength.actualLength);
            if(this.thisForm.controls["usuario"].errors.minlength.actualLength < this.thisForm.controls["usuario"].errors.minlength.requiredLength)
              this.fnMuestraMensaje("ERR", "El 'usuario' debe contener " + this.thisForm.controls["usuario"].errors.minlength.requiredLength + " o más caracteres.", true, false)
            return;
          }
        }
        if(this.thisForm.controls["nombre"].errors){
          if(this.thisForm.controls["nombre"].errors.required){
            this.fnMuestraMensaje("ERR", "Capture el 'nombre' del usuario.", true, false);
            return;
          }
          if(this.thisForm.controls["nombre"].errors.minlength){
            //console.log(this.thisForm.controls["nombre"].errors.minlength.actualLength);
            if(this.thisForm.controls["nombre"].errors.minlength.actualLength < this.thisForm.controls["nombre"].errors.minlength.requiredLength)
              this.fnMuestraMensaje("ERR", "El 'nombre' del usuario debe contener " + this.thisForm.controls["nombre"].errors.minlength.requiredLength + " o más caracteres.", true, false)
            return;
          }
        }
        if(this.thisForm.controls["email"].errors){
          if(this.thisForm.controls["email"].errors.required){
            this.fnMuestraMensaje("ERR", "Capture el 'email' del usuario.", true, false);
            return;
          }
          if(this.thisForm.controls["email"].errors.minlength){
            //console.log(this.thisForm.controls["email"].errors.minlength.actualLength);
            if(this.thisForm.controls["email"].errors.minlength.actualLength < this.thisForm.controls["email"].errors.minlength.requiredLength)
              this.fnMuestraMensaje("ERR", "El 'email' del usuario debe contener " + this.thisForm.controls["email"].errors.minlength.requiredLength + " o más caracteres.", true, false)
            return;
          }
        }
        if(this.thisForm.controls["rol"].errors.required){
          this.fnMuestraMensaje("ERR", "Capture el 'rol' del usuario.", true, false);
          return;
        }
      }
    }
    else{
      //console.log("EDITAR");
      if(this.thisForm.valid){
        var alertaJefe = false;
        if(this.thisForm.controls["rol"].value == 10){
          for(var j = 0; j < this.jefe.length; j++){
            alertaJefe = true;
            if(this.jefe[j].idPersona == this.data.id){
              alertaJefe = false;
           }
          }
          if(alertaJefe){
            //console.log("Ya existe un Jefe de Taquilla dado de alta!");
            this.fnMuestraMensaje("ERR", "Solo puede haber un 'Jefe de Taquilla' activo.", true, false);
            return;
          }
        }
        this.dataService.updUsuario(this.data.id, this.activo, this.data.item.idUsuario, this.thisForm.controls["nombre"].value, this.thisForm.controls["email"].value, this.thisForm.controls["rol"].value, this.idRolActual).subscribe(
                      rows => {   
                              this.resultado = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnUsuarioEditado());   
      } 
      else{
        if(this.thisForm.controls["nombre"].errors){
          if(this.thisForm.controls["nombre"].errors.required){
            this.fnMuestraMensaje("ERR", "Capture el 'nombre' del usuario.", true, false);
            return;
          }
          if(this.thisForm.controls["nombre"].errors.minlength){
            //console.log(this.thisForm.controls["nombre"].errors.minlength.actualLength);
            if(this.thisForm.controls["nombre"].errors.minlength.actualLength < this.thisForm.controls["nombre"].errors.minlength.requiredLength)
              this.fnMuestraMensaje("ERR", "El 'nombre' del usuario debe contener " + this.thisForm.controls["nombre"].errors.minlength.requiredLength + " o más caracteres.", true, false)
            return;
          }
        }
        if(this.thisForm.controls["email"].errors){
          if(this.thisForm.controls["email"].errors.required){
            this.fnMuestraMensaje("ERR", "Capture el 'email' del usuario.", true, false);
            return;
          }
          if(this.thisForm.controls["email"].errors.minlength){
            //console.log(this.thisForm.controls["email"].errors.minlength.actualLength);
            if(this.thisForm.controls["email"].errors.minlength.actualLength < this.thisForm.controls["email"].errors.minlength.requiredLength)
              this.fnMuestraMensaje("ERR", "El 'email' del usuario debe contener " + this.thisForm.controls["email"].errors.minlength.requiredLength + " o más caracteres.", true, false)
            return;
          }
        }
        if(this.thisForm.controls["rol"].errors.required){
          this.fnMuestraMensaje("ERR", "Capture el 'rol' del usuario.", true, false);
          return;
        }
      }
    }
  }

  fnUsuarioGuardado(){
    //console.log(this.resultado);
    if(this.resultado == 1){
      if(this.admonCorreo.length > 0){    
        var msg = "Usuario: '" + this.thisForm.controls["usuario"].value + "'∙";
        msg += "Nombre: '" + this.thisForm.controls["nombre"].value + "'∙";
        msg += "Correo: '" + this.thisForm.controls["email"].value + "'∙";
        msg += "Rol: '" + this.dataService.findItemInObject(this.rol, this.thisForm.controls["rol"].value, "idRol").rol + "'∙";
        msg += "Activo: '" + (this.activo ? 'SI' : 'NO') + "'∙";
        this.dataService.sendMailLog("Usuario nuevo", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                              rows => {   
                                      this.envioMail = rows
                                      },          
                              error => this.errMsg = <any>error,
                              () => this.fnEmailEnviado());     
      }
      this.fnMuestraMensaje("OK", "Registro almacenado", false, true);
    }
    else{
      if(this.resultado = -9999)
        this.errMsg = "Tu usuario no puede asignar roles superiores!"
      else
        this.errMsg = "Error al almacenar registro!" 
      this.fnMuestraMensaje("ERR", this.errMsg, true, false);
    }
  }  

  fnUsuarioEditado(){
        //console.log(this.resultado);
        if(this.resultado == 1){
          if(this.admonCorreo.length > 0){    
            var msg = "Usuario: '" + this.thisForm.controls["usuario"].value + "'∙";
            msg += "Nombre: '" + this.thisForm.controls["nombre"].value + "'∙";
            msg += "Correo: '" + this.thisForm.controls["email"].value + "'∙";
            msg += "Rol: '" + this.dataService.findItemInObject(this.rol, this.thisForm.controls["rol"].value, "idRol").rol + "'∙";
            msg += "Activo: '" + (this.activo ? 'SI' : 'NO') + "'∙";
            this.dataService.sendMailLog("Usuario editado » '" + this.data.item.idUsuario + "'.", msg, this.admonCorreo[0].mail, this.admonCorreo[0].nombre).subscribe(
                                  rows => {   
                                          this.envioMail = rows
                                          },          
                                  error => this.errMsg = <any>error,
                                  () => this.fnEmailEnviado());     
          }
          this.okMsg = "Registro actualizado"
          setTimeout(() => {
            this.okMsg = "";
            this.loading = false;
            this.dialogRef.close();
          }, this.tiempoMsg);
        }
        else{
          if(this.resultado = -9999)
            this.errMsg = "Tu usuario no puede asignar roles superiores!"
          else
            this.errMsg = "Error al actualizar registro!" 
          this.fnMuestraMensaje("ERR", this.errMsg, true, false);
        }    
  }

  fnEmailEnviado(){
    console.log("Correo enviado")
  }

}
